import { siteMeta } from "@/mocks/siteMeta";

const quickLinks = [
  { label: "最新可用地址", href: "#addresses" },
  { label: "APP入口与下载", href: "#app" },
  { label: "防走失指南", href: "#guide" },
  { label: "地址可用性自查", href: "#status" },
  { label: "访问方式对比", href: "#compare" },
  { label: "地址更新记录", href: "#log" },
  { label: "安全与防仿冒", href: "#security" },
  { label: "常见问题", href: "#faq" },
];

export default function SiteFooter() {
  return (
    <footer className="w-full bg-secondary-700 text-background-100">
      <div className="w-full px-4 md:px-6 py-14 md:py-16">
        <div className="max-w-6xl mx-auto grid grid-cols-1 md:grid-cols-3 gap-10">
          <div className="md:col-span-1">
            <div className="flex items-center gap-2.5">
              <span className="w-9 h-9 rounded-lg bg-primary-500 text-background-50 flex items-center justify-center">
                <i className="ri-play-circle-fill text-xl"></i>
              </span>
              <div className="leading-tight">
                <div className="font-heading font-bold text-lg text-background-50">{siteMeta.siteName}</div>
                <div className="text-xs text-secondary-200">网址发布页</div>
              </div>
            </div>
            <p className="mt-4 text-sm text-secondary-100 leading-relaxed">
              {siteMeta.slogan}。本页长期汇总 97视频 的最新网址、APP入口与官网防走失地址，
              当地址更换或无法打开时，回到这里即可快速找到可用的访问方式。
            </p>
            <div className="mt-5 inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-secondary-600 text-secondary-100 text-xs">
              <i className="ri-refresh-line"></i>
              最近更新 {siteMeta.updatedAt}
            </div>
          </div>

          <div className="md:col-span-1">
            <h3 className="font-heading font-semibold text-background-50 mb-4">页面导航</h3>
            <ul className="grid grid-cols-2 gap-x-4 gap-y-2.5">
              {quickLinks.map((link) => (
                <li key={link.href}>
                  <a
                    href={link.href}
                    className="text-sm text-secondary-100 hover:text-accent-300 transition-colors cursor-pointer whitespace-nowrap"
                  >
                    {link.label}
                  </a>
                </li>
              ))}
            </ul>
          </div>

          <div className="md:col-span-1">
            <h3 className="font-heading font-semibold text-background-50 mb-4">使用提示</h3>
            <ul className="flex flex-col gap-3 text-sm text-secondary-100">
              <li className="flex items-start gap-2">
                <i className="ri-bookmark-3-line text-accent-400 mt-0.5"></i>
                <span>建议把本页加入书签或添加到手机主屏幕，方便随时回访。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-file-copy-2-line text-accent-400 mt-0.5"></i>
                <span>同时记下一条主线路与一条备用线路，避免只依赖单一入口。</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-shield-check-line text-accent-400 mt-0.5"></i>
                <span>遇到索要敏感信息的页面应立即关闭，谨防仿冒站点。</span>
              </li>
            </ul>
          </div>
        </div>

        <div className="max-w-6xl mx-auto mt-10 pt-6 border-t border-secondary-600 flex flex-col sm:flex-row items-start sm:items-center justify-between gap-3">
          <p className="text-xs text-secondary-200 leading-relaxed">
            本站为公开信息汇总页，仅整理入口与访问方式，地址可能随运营调整而变化，请以本页展示为准。
          </p>
          <p className="text-xs text-secondary-200 whitespace-nowrap">
            © {new Date().getFullYear()} {siteMeta.siteName} 网址发布页
          </p>
        </div>
      </div>
    </footer>
  );
}